import { Component, OnDestroy, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { AdminService } from "@shared/services/admin.service";
import { StorageService } from "@core/services/storage.service";
import { UserService } from "@core/services/user.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit,OnDestroy {
  customize: any;
  activeUser: ActiveUser.ActiveUserModel;

  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  featuresData: any;

  public constructor(private titleService: Title,
                     private storageService: StorageService,
                     private adminService: AdminService,
                     public userService: UserService) {
    this.activeUser = this.userService.activeUser;
  }

  async ngOnInit(): Promise<void> {
    await this.getCustomization();
    this.injectUserGuiding()
    this.getFeaturesData();
    this.changeIcon();
    this.setTitle();
    this.injectUserGuiding()
  }

  injectUserGuiding() {
    if (!window.location.pathname.includes('/login') && this.customize?.userGuideActive) {
      const userGuidingScript = document.createElement("script");
      userGuidingScript.type = "text/javascript";
      // @ts-ignore
      window.setParametersForUserGuiding = () => {
        const userGuideData =
          {
            username: this.activeUser.username,
            name: this.activeUser.name,
            surname: this.activeUser.surname,
            fullName: this.activeUser.fullName,
            email: this.activeUser.email,
            companyName: this.activeUser.company?.name,
            companyRole: this.activeUser.companyRole,
            oobeyaRoles: this.activeUser.roles.map(role => role.name).join(',')
          }

        const checkUserGuiding = setInterval(() => {
          // @ts-ignore
          if (window.userGuiding && typeof window.userGuiding.identify === 'function') {
            // @ts-ignore
            window.userGuiding.identify(this.activeUser.id,userGuideData );
            clearInterval(checkUserGuiding);

          } else {
            console.log("Waiting for UserGuiding to be available...");
          }
        }, 300);
      }
      userGuidingScript.text = `(function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];
      var k=u.createElement(i);k.async=true;k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';f.parentNode.insertBefore(k,f);
      k.onload= window.setParametersForUserGuiding
      if(g[d])return;
      var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};
      var m=['previewGuide','finishPreview','track','identify','triggerNps','hideChecklist','launchChecklist'];

      for(var j=0;j<m.length;j+=1)
      {ug[m[j]]=ug.c(m[j]);
      }})(window,document,'script','userGuiding','userGuidingLayer','JMX84687K7SID');;`

      document.head.appendChild(userGuidingScript);
    }
  }

  changeIcon() {
    this.favIcon.href = this.customize?.favicon ?  this.customize?.favicon : 'assets/images/new-logo.png';
  }

  public setTitle() {
    this.titleService.setTitle(this.customize?.title ? this.customize?.title : 'Oobeya | Actionable insights on software quality and development efficiency.');
  }

  getCustomization(): Promise<any> {
    return new Promise(resolve => {
      this.adminService.getCustomization().pipe().subscribe((res) => {
        resolve(this.customize = res);
      }, error => {
        console.log('error occurred while fetching initial get customization', error);
      })
    })

  }

  getFeaturesData(): void {
    this.adminService.getFeatures()
      .pipe()
      .subscribe(response => {
        this.featuresData = response;
        this.storageService.set('features_data_individual', JSON.stringify(this.featuresData.find(item => item.key === 'INDIVIDUAL_SCORECARD').active));
        this.storageService.set('features_data_gm1', JSON.stringify(this.featuresData.find(item => item.key === 'GRANULARITY_METRIC_1').active));
        this.storageService.set('features_data_restriction', JSON.stringify(this.featuresData.find(item => item.key === 'USER_ACCESS_RESTRICTION').active));
      }, error => {
        console.log('error while fetching values', error);
      });
  }

  ngOnDestroy(): void {

  }
}
